import React from 'react';
import './DocTableCell.scss';

interface DocTableCellProps {
    children: JSX.Element | string
}

export const DocTableCell: React.FC<DocTableCellProps> = ({children}) => (
    <div className="doc-table-cell">{children}</div>
);
